import React from 'react'

function Locator() {
  return (
    <div className='nav-margin'>Locator</div>
  )
}

export default Locator